export const DOOR_GLASS_8 = '8';
export const DOOR_GLASS_10 = '10';
export const DOOR_GLASS_12 = '12';
export const DOOR_GLASS_876 = '876'; // 4+076+4mm
export const DOOR_GLASS_1076 = '1076'; // 5+5 075 SC
export const DOOR_GLASS_1276 = '1276'; // 6+6 075 SC
export const DOOR_GLASS_3276 = '3276'; // 2K
export const DOOR_GLASS_3276D = '3276D'; // 2K (D)

const doorGlassTypes = [
  DOOR_GLASS_8,
  DOOR_GLASS_10,
  DOOR_GLASS_12,
  DOOR_GLASS_876,
  DOOR_GLASS_1076,
  DOOR_GLASS_1276,
  DOOR_GLASS_3276,
  DOOR_GLASS_3276D,
];

export default doorGlassTypes;
